import React from 'react';
export const HeroSection = () => {
  return <section id="home" className="w-full min-h-screen flex items-center relative" data-id="element-31">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0" data-id="element-32">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mgkTKELmddAtkSK2GwbSzo/Gemini_Generated_Image_atlna1atlna1atln.png" alt="Copenhagen cityscape" className="w-full h-full object-cover" data-id="element-33" />
        <div className="absolute inset-0 bg-white bg-opacity-90" data-id="element-34"></div>
      </div>
      <div className="container mx-auto px-6 z-10" data-id="element-35">
        <div className="max-w-3xl" data-id="element-36">
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-10 leading-tight" data-id="element-37">
            Helping teams build{' '}
            <span className="text-blue-700" data-id="element-38">better products</span> through
            strategic clarity.
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 mb-12 leading-relaxed" data-id="element-39">
            I help product teams align their vision, define clear objectives,
            and create actionable roadmaps that drive business growth.
          </p>
          <div className="flex flex-col sm:flex-row gap-6" data-id="element-40">
            <a href="#services" className="px-8 py-4 bg-gray-900 text-white font-medium rounded-none hover:bg-gray-800 transition-colors text-center text-sm uppercase tracking-wider" data-id="element-41">
              Explore Services
            </a>
            <a href="#contact" className="px-8 py-4 bg-white text-gray-900 font-medium rounded-none border border-gray-900 hover:bg-gray-50 transition-colors text-center text-sm uppercase tracking-wider" data-id="element-42">
              Get in Touch
            </a>
          </div>
        </div>
      </div>
    </section>;
};